<template>
  <section class="relative z-50" :style="{ backgroundColor: bgColor }">
    <div class="px-4 mx-auto max-w-5xl xl:px-0 md:px-6">
      <div class="flex flex-col gap-x-2 gap-y-2 items-center py-4 lg:flex-row">
        <div>
            <svg width="127" height="18"  class="w-32 xl:w-auto"  viewBox="0 0 127 18" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<rect width="19" height="18" fill="url(#pattern0_2538_4363)"/>
<rect x="27" width="19" height="18" fill="url(#pattern1_2538_4363)"/>
<rect x="54" width="19" height="18" fill="url(#pattern2_2538_4363)"/>
<rect x="81" width="19" height="18" fill="url(#pattern3_2538_4363)"/>
<rect x="108" width="19" height="18" fill="url(#pattern4_2538_4363)"/>
<defs>
<pattern id="pattern0_2538_4363" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image0_2538_4363" transform="scale(0.0526316 0.0555556)"/>
</pattern>
<pattern id="pattern1_2538_4363" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image0_2538_4363" transform="scale(0.0526316 0.0555556)"/>
</pattern>
<pattern id="pattern2_2538_4363" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image0_2538_4363" transform="scale(0.0526316 0.0555556)"/>
</pattern>
<pattern id="pattern3_2538_4363" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image0_2538_4363" transform="scale(0.0526316 0.0555556)"/>
</pattern>
<pattern id="pattern4_2538_4363" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image0_2538_4363" transform="scale(0.0526316 0.0555556)"/>
</pattern>
<image id="image0_2538_4363" width="19" height="18" preserveAspectRatio="none" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAASCAYAAAC5DOVpAAABxUlEQVQ4jWL838hACJxlYGBQYWBguMPAwGCMUzEDAwMAAAD//2IiYFIYAwODEQMDAx+UBvGxAwYGBgAAAAD//yJkWBcBPgIwMDAAAAAA///CZ1goAwODPJoYiA8SxwQMDAwAAAAA///CZhgLAwODAQMDQz8OPSBxkDxIHQIwMDAAAAAA//980DEJACAAAMFLIYJJBDPY0iyO1nA2gIjg7PrT8TcUVATk9yd+xAkDEwsdG+0AAAD//wLF5n88GokHDAwMAAAAAP//AnnzNlVMYmC4DQAAAP//AhlmxsDAcJNCg24yMDCYAQAAAP//Ahn2gYGBwYQCA0H6TBgYGD4AAAAA//+CxeYXqMA5Eg0CqQfp+8LAwMAAAAAA//9CThoggWgSDQOpBxvEwMDAAAAAAP//Qk9nAiQahlDPwMAAAAAA//9CN8yJRMMQ6hkYGAAAAAD//0I3TIZEwxDqGRgYAAAAAP//QjfMFosGUAqvgtLoAKGegYEBAAAA//9CN0wYif2QgYEhiIGBwYqBgaEdSoP4IHFM9QwMDAAAAAD//0I3bDM0v01jYGDQZGBgWI8mD+KDxEHyIHUg9RDAwMAAAAAA//8DAHlhLFQe3TpUAAAAAElFTkSuQmCC"/>
</defs>
</svg>
        </div>

        <p :style="{ color: textColor }" class="text-sm !leading-4 xl:text-lg md:text-base font-ww-regular lg:text-left text-center">
          {{ bannerText }}
        </p>
      </div>
    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  bgColor: {
    type: String,
    default: "#07141D"
  },
  textColor: {
    type: String,
    default: "#ffffff"
  },
  bannerText: {
    type: String,
    default: "10,000+ women are choosing mushroom coffee to feel sharper, steadier, and more energized every day."
  },
  ratingAriaLabel: {
    type: String,
    default: "5 out of 5 stars rating"
  }
})

defineBuilderComponent({
  friendlyName: "Banner - Rating With Text",
  inputs: [
    {
      name: "bgColor",
      type: "color",
      defaultValue: "#07141D"
    },
    {
      name: "textColor",
      type: "color",
      defaultValue: "#ffffff"
    },
    {
      name: "bannerText",
      type: "longText",
      defaultValue: "10,000+ women are choosing mushroom coffee to feel sharper, steadier, and more energized every day."
    },
    {
      name: "ratingAriaLabel",
      type: "text",
      defaultValue: "5 out of 5 stars rating"
    }
  ]
})
</script>
